import { useTranslation } from 'react-i18next';
import './NetworkStatusIndicator.css';

const NetworkStatusIndicator = ({ isServerConnected, lastChecked }) => {
  const { t } = useTranslation();

  // Check if connection status display is disabled
  if (localStorage.getItem('DISABLE_CONNECTION_STATUS') === 'TRUE') {
    return null;
  }

  if (isServerConnected) {
    return null;
  }

  const getStatusInfo = () => {
    return {
      status: 'offline',
      message: t('Server connection failed'),
      icon: '⚠️',
      color: '#f44336',
    };
  };

  const statusInfo = getStatusInfo();
  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  return (
    <div
      className={`network-status-indicator ${statusInfo.status}`}
      style={{ borderLeftColor: statusInfo.color }}
    >
      <div className="network-status-content">
        <span className="network-status-icon">{statusInfo.icon}</span>
        <div className="network-status-text">
          <div className="network-status-message">{statusInfo.message}</div>
          <div className="network-status-time">
            {t('Last checked')}: {formatTime(lastChecked)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkStatusIndicator;
